import _ from "lodash";
import { postAuthLogin, postAuthLogout, refreshToken } from "@/api/login";
import { getUserGetUserByLoginToken } from "@/api/userCenter";
import { getToken, setToken, setExpiresIn, removeToken } from "@/utils/auth";
import axios from "axios";
const userModel = function () {
  return {
    namespaced: true,
    state: {
      token: getToken(),
      name: "",
      avatar: "",
      roles: [],
      permissions: [],
      userInfo: [],
    },
    mutations: {
      SET_TOKEN: (state, token) => {
        state.token = token;
      },
      SET_EXPIRES_IN: (state, time) => {
        state.expires_in = time;
      },
      SET_NAME: (state, name) => {
        state.name = name;
      },
      SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
      },
      SET_ROLES: (state, roles) => {
        state.roles = roles;
      },
      SET_PERMISSIONS: (state, permissions) => {
        state.permissions = permissions;
      },
      SET_USER: (state, userInfo) => {
        //当前登录用户信息
        state.userInfo = userInfo;
      },
    },

    actions: {
      // 登录
      Login({ commit }, userInfo) {
        // const username = userInfo.username.trim();
        // const password = userInfo.password;
        // const code = userInfo.code;
        // const uuid = userInfo.uuid;
        return new Promise((resolve, reject) => {
          postAuthLogin({ ...userInfo })
            .then((res) => {
              let data = res.data;
              setToken(data.tokenValue);
              commit("SET_TOKEN", data.tokenValue);
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },

      // 获取用户信息
      GetInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
          console.log(getToken());

          getUserGetUserByLoginToken()
            .then((res) => {
              console.log(res, "用户信息");
              const user = res.data;
              if (user.roleCode) {
                // 验证返回的roles是否是一个非空数组
                commit("SET_ROLES", user.roleCode.split(","));
              } else {
                commit("SET_ROLES", []);
              }
              commit("SET_USER", user);
              commit("SET_NAME", user.nikeName);
              resolve(res);
            })
            .catch((error) => {
              reject(error);
            });
        });
      },

      // 刷新token
      RefreshToken({ commit, state }) {
        return new Promise((resolve, reject) => {
          refreshToken(state.token)
            .then((res) => {
              setExpiresIn(res.data);
              commit("SET_EXPIRES_IN", res.data);
              resolve();
            })
            .catch((error) => {
              reject(error);
            });
        });
      },

      // 退出系统
      LogOut({ commit, state }) {
        return new Promise((resolve, reject) => {
          postAuthLogout(state.token)
            .then(() => {
              console.log("退出系统---resolve");
              commit("SET_TOKEN", "");
              commit("SET_ROLES", []);
              commit("SET_PERMISSIONS", []);
              removeToken();
              resolve();
            })
            .catch((error) => {
              console.log("退出系统---reject");

              commit("SET_TOKEN", "");
              commit("SET_ROLES", []);
              commit("SET_PERMISSIONS", []);
              removeToken();
              reject(error);
            });
        });
      },

      // 前端 登出
      FedLogOut({ commit }) {
        return new Promise((resolve) => {
          commit("SET_TOKEN", "");
          removeToken();
          resolve();
        });
      },
    },
  };
};
export default userModel();
